var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHitLikeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33317 6.00007H3.33317V14.0001H1.33317C1.15636 14.0001 0.98679 13.9298 0.861766 13.8048C0.736742 13.6798 0.666504 13.5102 0.666504 13.3334V6.66674C0.666504 6.48993 0.736742 6.32036 0.861766 6.19534C0.98679 6.07031 1.15636 6.00007 1.33317 6.00007V6.00007ZM4.86184 5.13807L9.1285 0.871408C9.18521 0.814537 9.26055 0.780052 9.34065 0.774295C9.42076 0.768539 9.50025 0.791897 9.5645 0.840074L10.1332 1.26674C10.2911 1.3853 10.4104 1.54798 10.476 1.73424C10.5416 1.92051 10.5506 2.12204 10.5018 2.31341L9.73317 5.33341H13.9998C14.3535 5.33341 14.6926 5.47388 14.9426 5.72393C15.1927 5.97398 15.3332 6.31312 15.3332 6.66674V8.06941C15.3334 8.24365 15.2994 8.41623 15.2332 8.57741L13.1698 13.5874C13.1195 13.7096 13.034 13.814 12.9242 13.8875C12.8144 13.9609 12.6853 14.0001 12.5532 14.0001H5.33317C5.15636 14.0001 4.98679 13.9298 4.86177 13.8048C4.73674 13.6798 4.6665 13.5102 4.6665 13.3334V5.60941C4.66654 5.43261 4.7368 5.26307 4.86184 5.13807Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitLikeWhite);
export default __webpack_public_path__ + "static/media/hit_like_white.f6446b05117fd7a31661a26b2966d2d5.svg";
export { ForwardRef as ReactComponent };